import { render, staticRenderFns } from "./reportIMSNTSRatioReport.vue?vue&type=template&id=251e6210&scoped=true&"
import script from "./reportIMSNTSRatioReport.vue?vue&type=script&lang=js&"
export * from "./reportIMSNTSRatioReport.vue?vue&type=script&lang=js&"
import style0 from "./reportIMSNTSRatioReport.vue?vue&type=style&index=0&id=251e6210&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251e6210",
  null
  
)

export default component.exports